import React from 'react';
import { useTheme } from 'styled-components';
import useBreakpoint from 'Common/hooks/useBreakpoint';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';
import PublicationCard, { PublicationCardProps } from 'Components/Card/Publication';

import HeroBanner, { MakeWavesHeroBannerProps } from 'Modules/HeroBanner/MakeWaves';
import PublicationPromoPoint, { PublicationPromoPointProps } from 'Modules/PromoPoint/Publication';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: MakeWavesHeroBannerProps;
    brochurePromoPoint: PublicationPromoPointProps;
    prospectusCards?: PublicationCardProps[];
    otherBrochureCards?: PublicationCardProps[];
}

const ProspectusesAndPublications: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, prospectusCards, brochurePromoPoint, otherBrochureCards } =
        props;
    const { breakpoints } = useTheme();

    const isDesktop = useBreakpoint(breakpoints.large.value);

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} backgroundColourWhite />
            <HeroBanner {...heroBanner} />
            {prospectusCards && (
                <Section
                    paddingTop={isDesktop ? 1 : 0}
                    paddingBottom={2}
                    background
                    id="prospectus-cards"
                >
                    <Grid rowGap={isDesktop ? '5rem' : '3.5rem'}>
                        {prospectusCards.map(card => (
                            <Col
                                m={prospectusCards.length === 1 ? [4, 10] : 6}
                                s={12}
                                key={card.id}
                            >
                                <PublicationCard {...card} />
                            </Col>
                        ))}
                    </Grid>
                </Section>
            )}
            <PublicationPromoPoint {...brochurePromoPoint} />
            {otherBrochureCards && (
                <Section paddingTop={2} paddingBottom={2} id="other-brochure-cards">
                    <Grid rowGap={isDesktop ? '5rem' : '3.5rem'}>
                        {otherBrochureCards.map(card => (
                            <Col key={card.id} l={4} m={6}>
                                <PublicationCard {...card} />
                            </Col>
                        ))}
                    </Grid>
                </Section>
            )}
        </Main>
    );
};

export default ProspectusesAndPublications;
